import de from './de';
import en from './en';
import enGB from './en-GB';
import esMX from './es-MX';
import fr from './fr';
import it from './it';

export default {
  en,
  'en-GB': enGB,
  de,
  fr,
  it,
  'es-MX': esMX,
};
